"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
const jsonparser_1 = require("../requests/jsonparser");
const category_1 = require("./category");
const album_1 = require("./album");
class Curated extends base_1.BaseModel {
}
__decorate([
    jsonparser_1.JsonProperty({ type: 'false' }),
    __metadata("design:type", String)
], Curated.prototype, "ISHELPERMODEL", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'Curated' }),
    __metadata("design:type", String)
], Curated.prototype, "MODELNAME", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string' }),
    __metadata("design:type", String)
], Curated.prototype, "id", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'Date?' }),
    __metadata("design:type", String)
], Curated.prototype, "updated_at", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'Date?' }),
    __metadata("design:type", String)
], Curated.prototype, "created_at", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'number' }),
    __metadata("design:type", Number)
], Curated.prototype, "position", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'boolean?' }),
    __metadata("design:type", Boolean)
], Curated.prototype, "is_followed", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string' }),
    __metadata("design:type", String)
], Curated.prototype, "title", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], Curated.prototype, "description", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string' }),
    __metadata("design:type", String)
], Curated.prototype, "slug", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], Curated.prototype, "subtitle", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string?' }),
    __metadata("design:type", String)
], Curated.prototype, "curator", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string' }),
    __metadata("design:type", String)
], Curated.prototype, "image", void 0);
__decorate([
    jsonparser_1.JsonProperty({ type: 'string' }),
    __metadata("design:type", String)
], Curated.prototype, "image_thumbnail", void 0);
__decorate([
    jsonparser_1.JsonProperty({ clazz: category_1.Category, type: 'Category' }),
    __metadata("design:type", category_1.Category)
], Curated.prototype, "category", void 0);
__decorate([
    jsonparser_1.JsonProperty({ clazz: album_1.Album, type: 'Album?' }),
    __metadata("design:type", Array)
], Curated.prototype, "albums", void 0);
exports.Curated = Curated;
